import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import {CustomProperty} from '../../../models/CustomProperty';
import {CustomPropertyService} from '../../../services/custom-property.service';

@Injectable()
export class CustomPropertiesResolver implements Resolve<Array<CustomProperty>> {

    resolve(): Observable<Array<CustomProperty>> {

        return this.customPropertyService.getCustomerCustomProperties();
    }

    constructor(private customPropertyService: CustomPropertyService) { }
}
